import { createClient } from '@/shared/api';
import SUGGEST_STRIP_COMMENT from '@/entities/strip/api/mutations/suggestStripComment';

export type SuggestStripCommentResult = {
  isSuccess: boolean;
  message: string;
  comment: string;
};

// TODO(ts): typed as the SuggestStripCommentInput GraphQL input once its server-side shape is documented
/**
 * Requests a suggested technician comment for a strip. Runs the suggestStripComment mutation with the supplied variables and returns its field, tolerating a nullish response.
 *
 * @param variables - Mutation variables carrying the strip context input.
 * @returns A promise resolving to the suggested strip comment result.
 */
const handleSuggestStripComment = async (variables: { input: any }) => {
  const client = await createClient();
  const result = await client.mutate<{ suggestStripComment: SuggestStripCommentResult }>({
    mutation: SUGGEST_STRIP_COMMENT,
    variables,
  });
  const { suggestStripComment } = result?.data || {};
  return suggestStripComment;
};

export default handleSuggestStripComment;
